<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-05 10:09:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:02:42
 * @FilePath: \mrc-base-server-view\src\views\mrc_system_admin\detail\index.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <div>
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :show_del="false"
                         :showEdit="hasBtn('edit-platform-administator')"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"></mrc_ess_iconGroup>
      <base-info @success="success"
                 :disabled="disabled"
                 :loading="loading"
                 :paramsData="params"
                 @cancel="cancel"></base-info>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  mrc_admin_info,
  mrc_admin_update,
} from '@/service/api/mrc_system_admin'
import baseInfo from '../modules/baseInfo'
export default {
  components: { baseInfo },
  props: {},
  data () {
    return {
      disabled: true,
      loading: false,
      params: {},
      skeletonloading: false,
    }
  },
  validations: {},
  computed: {},
  created () { },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_platform_administrator'
          this.$store.commit('set_page_title', 'label_edit_platform_administrator')
        }
        else {
          this.$route.meta.title = 'label_view_platform_administrator'
          this.$store.commit('set_page_title', 'label_view_platform_administrator')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.$nextTick(async () => {
      if (!this.$store.state.iconstatus) {
        this.disabled = false
      }
      const uuid = this.$route.params.uuid || this.$store.state.uuid
      const name = this.$store.getters.subPage_name
      this.params.uuid = uuid
      await this.getInfo()
    })
  },

  methods: {
    async success (obj) {
      this.loading = true
      delete obj.user_pwd
      const res = await mrc_admin_update({
        ...obj,
        org_level_uuid: this.$store.state.userData.org_level_uuid,
      })
      if (res.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })
        // this.$router.go(-1)
        await this.getInfo()
        this.disabled = !this.disabled
      }
      this.loading = false
    },
    async cancel () {
      await this.getInfo()
      this.disabled = !this.disabled
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(async () => {
      //     this.disabled = !this.disabled
      //     await this.getInfo()
      //   })
      //   .catch(() => { })
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    async getInfo () {
      this.skeletonloading = true
      const res = await mrc_admin_info({
        uuid: this.params.uuid,
      })
      if (res.code == 200) {
        const {
          status,
          user_account,
          user_pwd,
          user_primary_email,
          clients_uuid,
          user_name,
          uuid,
        } = res.data
        this.params = Object.assign(
          {},
          {
            status,
            user_account,
            user_pwd,
            user_primary_email,
            clients_uuid,
            user_name,
            uuid,
          }
        )
      }
      this.skeletonloading = false
    },
  },
}
</script>

<style scoped></style>
